import {Button, Form} from 'antd';
import FormGroup from 'components/formItems/FormGroup';
import Toast from 'components/Toast';
import {useState, useEffect} from 'react';
import SERVICES from 'services';

const DiplomaWork = () => {
	const [form] = Form.useForm();
	const [uploadAllowed, setUploadAllowed] = useState(false);
	const [loading, setLoading] = useState(false);
	const [errors, setErrors] = useState({});
	const [initialValues, setInitialValues] = useState({});

	useEffect(() => {
		SERVICES.USER.checkDiplomaWork().then(res => {
			setUploadAllowed(res.data.diplomaWorksUploadAllowed);
		});
	}, []);

	const onSubmit = (values: any) => {
		setLoading(true);
		SERVICES.USER.uploadDiplomaWork(values)
			.then(() => {
				Toast.success('Ձեր աշխատանքև հաջողությամբ ուղարկվել է');
			})
			.catch(e => {
				setErrors(e.message);
				if (typeof e.message === 'string') {
					Toast.error(e.message);
				}
			})
			.finally(() => {
				setLoading(false);
			});
	};

	if (!uploadAllowed)
		return (
			<div style={{justifySelf: 'center', alignSelf: 'center'}}>
				Ֆայլերի նեռբերնում դեռևս հասանելի չէ
			</div>
		);

	return (
		<Form form={form} onFinish={onSubmit} layout="vertical">
			<div style={{marginTop: 20, marginBottom: 20, background: 'white', padding: 25}}>
				Աշխատանքները հնարավոր է ուշացումով հանձնել հաստատված ժամկետից հետո մինչև X օր։ X օրից հետո
				աշխատանքը չի ընդունվելու և դուք ստիպված կլինեք այն հանձնելու երկրորդ քննաշրջանի ընթացքում
				(վերահանձնում):
				<br />
				<br />
				Ուշացման յուրաքանչյուր օրը (24 ժամ կտրվածքով) տուգանվելու է 1 միավորով, իսկ աշխատանքի միայն
				մեկ տարբերակն (հայերեն կամ ֆրանսերեն) ուշացնելու դեպքում 0,5 միավորով։
			</div>
			<FormGroup
				formErrors={errors}
				formInitialValues={initialValues}
				tabFields={[
					{
						type: 'file',
						label: 'Աշխատանքը՝ հայերեն',
						colProps: {xs: 24, lg: 12},
						isRequired: false,
						name: 'fileInArmenian'
					},
					{
						type: 'file',
						label: 'Աշխատանքը՝ ֆրանսերեն',
						colProps: {xs: 24, lg: 12},
						isRequired: false,
						name: 'fileInFrench'
					}
				]}
			/>
			<div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end'}}>
				<Button htmlType="submit" type="primary" style={{maxWidth: 150}} disabled={loading}>
					Պահպանել
				</Button>
			</div>
		</Form>
	);
};

export default DiplomaWork;
